// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*@import '../styles/sharedStyles';*/\n.icon--order-success svg path[data-v-750b9b8f] {\n  -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;\n  animation: checkmark 0.25s ease-in-out 0.7s backwards;\n}\n.icon--order-success svg circle[data-v-750b9b8f] {\n  -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;\n  animation: checkmark-circle 0.6s ease-in-out backwards;\n}", ""]);
// Exports
module.exports = exports;
